import { render, staticRenderFns } from "./InvestmentStrategyResult.vue?vue&type=template&id=c441518c&scoped=true&"
import script from "./InvestmentStrategyResult.vue?vue&type=script&lang=ts&"
export * from "./InvestmentStrategyResult.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentStrategyResult.vue?vue&type=style&index=0&id=c441518c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c441518c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VForm,VRow})
